<template>
  <v-dialog v-model="dOpenComponente" persistent width="1000px" content-class="">
    <v-card>
      <!-- cabecera del dialogo -->
      <v-toolbar dark class="datModalTitleContainer">
        <v-toolbar-title>
          {{ dInformeComponente.nombre }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="fCerrarVentana()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-flex xs12 class="pl-2 datModalSubtitle mb-3">
            {{ dInformeComponente.descripcion }}
          </v-flex>
          <v-layout row wrap justify-space-between>

            <v-flex xs12 sm6 md4 px-2 v-if="dRole !== 'CLIENTE'">
              <p class="datLabelGroup pt-0">
                {{ $t('proveedor') }}
              </p>
              <!-- Proveedores -->
              <DatTextFieldCode ref="TablaDeProveedores" :pDataPass="dDataProveedor" @alert="fAlert"
                @select="fSelectProveedor" @clean="fCleanProveedor"></DatTextFieldCode>
            </v-flex>
            <template v-if="dRole !== 'SUCURSAL'">
              <v-flex v-if="dRole !== 'CLIENTE' && dRole !== 'MULTISUCURSAL'" md10 px-2>
                <DatTextFieldCode ref="TablaDeClientes" :pDataPass="dDataClient" @select="fSelectClient"
                  @clean="fCleanClient" @alert="fAlert"></DatTextFieldCode>
              </v-flex>
              <v-flex v-if="dNotOnPremise" md10 px-2>
                <DatTextFieldCode ref="TablaDeSucursal" :pDataPass="dDataSucursal" @select="fSelectSucursal"
                  @clean="fClearSucursal" @alert="fAlert"></DatTextFieldCode>
              </v-flex>
            </template>
            <v-flex xs12 sm6 md3 px-2>
              <p class="datLabelGroup pt-0">
                {{ $t('fecha') }}
              </p>
              <v-menu ref="fechaIniMenu" lazy v-model="dDatosFechas.fechaIniMenu" transition="scale-transition" offset-y
                full-width :nudge-right="40" min-width="290px" :close-on-content-click="false">
                <v-text-field clearable required color="datPrimary" slot="activator" :label="this.$t('fechaInicial')"
                  v-model="dDatosFechas.fechaIniDateString" append-icon="event" readonly
                  :rules="[rules.checkfechas]"></v-text-field>
                <v-date-picker :min="dDatosFechas.fechaMinIni" color="datSecondary" v-model="dDatosFechas.fechaIniDate"
                  no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="$refs.fechaIniMenu.save(dDatosFechas.fechaIniDate)">
                </v-date-picker>
              </v-menu>
              <v-menu ref="fechaFinMenu" v-model="dDatosFechas.fechaFinMenu" lazy transition="scale-transition" offset-y
                full-width :nudge-right="40" min-width="290px" :close-on-content-click="false">
                <v-text-field clearable v-model="dDatosFechas.fechaFinDateString" required color="data-colorcorp1"
                  slot="activator" :label="this.$t('fechaFinal')" append-icon="event" readonly
                  :rules="[rules.checkfechas]"></v-text-field>
                <v-date-picker :min="dDatosFechas.fechaMinFin" v-model="dDatosFechas.fechaFinDate" no-title scrollable
                  :first-day-of-week="1" locale="es-es" @input="$refs.fechaFinMenu.save(dDatosFechas.fechaFinDate)">
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center justify-space-between>
            <v-flex xs12 sm1 px-2 ml-auto>
              <v-layout justify-end>
                <v-tooltip top>
                  <v-btn small slot="activator" class="datSecondaryBtnIcon" icon flat @click="fLimpiarFiltros()">
                    <v-icon>mdi-broom</v-icon>
                  </v-btn>
                  <span>{{ $t('limpiar') }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <v-btn small slot="activator" class="datSecondaryBtn" flat @click="fBuscarFacturas()">
                    <span>
                      {{ dBuscarTxt }}
                    </span>
                    <v-icon small right>mdi-magnify</v-icon>
                  </v-btn>
                  <span>{{ dBuscarTxt }}</span>
                </v-tooltip>
              </v-layout>
            </v-flex>
          </v-layout>
          <div class="px-3">
            <v-data-table v-model="dSelected" select-all :rows-per-page-text="dTextNumPag" :headers="dHeaders"
              :items="dAlbaranes" item-key="numped" :no-data-text="this.$t('noResultados')"
              :no-results-text="this.$t('noResultados')" v-bind:pagination.sync="dPagination" :loading="dLoading"
              :total-items="dTotalItems" :rows-per-page-items="dRowsPerPageArray" class="mt-1 mb-4">
              <template slot="headers" slot-scope="props">
                <tr class="data-gbGreyLight">
                  <th class="text-xs-center" v-for="header in props.headers" :key="header.text" :id="header.value"
                    :class="[header.value === 'seleccion' ? 'px-2' : '', 'column', (header.sortable) ? 'sortable' : '', dPagination.descending ? 'desc' : 'asc', header.value === dPagination.sortBy ? 'active' : '', 'text-xs-' + header.align]"
                    @click="fCambiaOrden(header)">
                    <template v-if="header.value === 'seleccion'">
                      <v-layout text-xs-center>
                        <v-flex xs12 sm1 px-2 ml-auto mr-auto>
                          <v-checkbox v-if="header.value === 'seleccion'" :input-value="props.all"
                            :indeterminate="props.indeterminate" @click.stop="fToggleAll" v-model="dSelectedAll" primary
                            hide-details></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </template>
                    <template v-else>
                      <v-icon v-if="header.sortable">arrow_upward</v-icon>
                      {{ header.text }}
                    </template>
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td v-if="dNotOnPremise" class="text-xs-center">
                  <v-layout text-xs-center>
                    <v-flex xs12 sm1 px-2 ml-auto mr-auto>
                      <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                    </v-flex>
                  </v-layout>
                </td>
                <td class="text-xs-center">{{ fFormatPedido(props.item.tipoPedido) }}</td>
                <td class="text-xs-center">{{ props.item.proveedor }}</td>
                <td class="text-xs-center">{{ props.item.nombreProv }}</td>
                <td class="text-xs-center">{{ props.item.numAlbaran }}</td>
                <td class="text-xs-center">{{ formatDate(props.item.fechaEntrada) }}</td>
                <td class="text-xs-center">
                  <v-btn flat icon>
                    <v-icon @click="fDownloadReport(props.item)">mdi-file-pdf-box</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>

// SERVICIOS
import SrvImpresion from '@/services/srv-impresion'
import SrvGeneral from '@/services/srv-general'

// COMPONENTES
import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'
import DatTextFieldCodeSubfield from '@/components_datadec/DatTextFieldCodeSubfield'

export default {
  name: 'ShpReimpresionFacturas',
  components: {
    DatTextFieldCode,
    DatTextFieldCodeSubfield
  },
  props: {
    pInformeComponente: {
      type: Object,
      required: true
    },
    paramsReimpresionFacturas: {
      type: Object,
      required: false,
      default: null
    },
    pLimitDate: {
      type: Object,
      required: false,
      default: {}
    }
  },
  data() {
    return {
      // Titulo para el componente Dialog
      dTitleLoading: '',
      dDataSucursal: {},
      dBuscarTxt: this.$t('buscar'),
      dLoading: false,
      dPagination: { 'sortBy': 'fechaEntrada', 'descending': true, 'rowsPerPage': 5 },
      dFilters: [],
      dRowsPerPageArray: [5, 15, 25, 50],
      dRowsPerPage: 5,
      dNumeroAlbaran: '',
      dOpenComponente: true,
      dInformeComponente: null,
      dTotalItems: 0,
      dFirstCharge: 0,
      dTextNumPag: this.$t('factText'),
      dSelectedAll: false,
      dDatosFechas: {
        'fechaIniMenu': false,
        'fechaIniDate': '',
        'fechaIniDateString': '',
        'fechaMinIni': '',
        'fechaFinMenu': false,
        'fechaFinDate': '',
        'fechaFinDateString': '',
        'fechaMinFin': ''
      },
      dNotOnPremise: true,
      dErrorMsgProveedor: [],
      dSelectProveedor: { codigo: '', nombre: '' },
      dRequestProv: {
        empresa: this.$store.getters.getAutenticacion.empresa,
        estado: 'A',
        conCompras: 'N'
      },
      dRequestClient: { empresa: this.$store.getters.getAutenticacion.empresa },
      dSelectClientIni: { codigo: '', nombre: '' },
      dSelectSucursal: { sucursal: '', nombreSucursal: '' },
      dRole: '',
      dHeaders: [],
      dDateFormats: {
        'default': 'DD/MM/YYYY',
        'years': 'YYYY-MM-DD'
      },
      dDataProveedor: {},
      dAlbaranes: [],
      rules: {
        /*
         * Regla para comprobar fecha de creacion
         */
        checkfechas: (value) => {
          if ((this.dDatosFechas.fechaIniDateString !== undefined) && (this.dDatosFechas.fechaFinDateString !== undefined) &&
            (this.dDatosFechas.fechaIniDateString !== null) && (this.dDatosFechas.fechaFinDateString !== null) &&
            (this.dDatosFechas.fechaIniDateString !== '') && (this.dDatosFechas.fechaFinDateString !== '')) {
            const fechaIniDate = this.$moment(this.dDatosFechas.fechaIniDateString, this.dDateFormats.default)
            const fechaFinDate = this.$moment(this.dDatosFechas.fechaFinDateString, this.dDateFormats.default)
            if (fechaIniDate <= fechaFinDate) {
              this.fValidateOtherRules()
              return true
            } else {
              return this.$t('fechaInicialMayorFinal')
            }
          } else {
            return true
          }
        }
      },
      dSelected: [],
      dAlbaraneseleccionada: false
    }
  },
  watch: {
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFechas.fechaIniDate': function (val, oldVal) {
      if (val !== null) {
        this.dDatosFechas.fechaIniDateString = this.$moment(val, this.dDateFormats.years).format(this.dDateFormats.default)
      }
    },
    /*
     * Espera el cambio de la fecha para cambiar el formato
     */
    'dDatosFechas.fechaFinDate': function (val, oldVal) {
      if (val !== null) {
        this.dDatosFechas.fechaFinDateString = this.$moment(val, this.dDateFormats.years).format(this.dDateFormats.default)
      }
    },
    /**
     * Comprueba las modificaciones de value
     */
    dPagination: {
      handler() {
        this.dSelectedAll = false
        if (this.dFirstCharge > 0) {
          this.fLoadInvoices(this.dPagination.sortBy, this.dPagination.descending, this.dPagination.page, this.dPagination.rowsPerPage, '', [])
        }
        this.dFirstCharge++
      },
      deep: true
    },
    dSelected: {
      handler() {
        if (this.dSelected.length > 0) {
          this.dAlbaraneseleccionada = true
        } else {
          this.dAlbaraneseleccionada = false
        }
      }
    },
    dSelectedAll: {
      handler() {
        this.dAlbaranes.forEach(item => {
          item.selected = (this.dSelectedAll)
        })
      }
    }
  },
  created() {
    this.fLimitFechas()
    this.fIniciarFechas()
    this.dInformeComponente = this.pInformeComponente
    this.fIniciarVariables()
  },
  methods: {
    fSelectProveedor(item) {
      if (item && item != null) {
        this.dSelectProveedor.codigo = item.codigo
        this.dSelectProveedor.nombre = item.nombre
      }
    },
    fCleanProveedor() {
      if (this.$refs.TablaDeProveedores !== undefined) {
        this.$refs.TablaDeProveedores.fClean()
      }
      this.dSelectProveedor = []
    },
    fCerrarVentana() {
      this.fLimpiarFiltros()
      this.$emit('close')
    },
    fEventLoading() {
      this.$emit('loading')
      this.dLoading = !this.dLoading
    },
    fIniciarVariables() {
      this.dHeaders = [
        { text: '', align: 'left', value: '', sortable: false, class: 'px-0', width: '10px', fixed: true },
        { text: this.$t('tipoPedido'), align: 'left', value: 'tipoPedido', sortable: true },
        { text: this.$t('proveedor'), align: 'left', value: 'proveedor', sortable: true },
        { text: this.$t('nombre'), align: 'left', value: 'nombreCliente', sortable: true },
        { text: this.$t('numeroAlbaranCorto'), align: 'left', value: 'numAlbaran', sortable: true },
        { text: this.$t('fecha'), value: 'fechaEntrada', sortable: true },
        { text: this.$t('descarga'), value: this.$t('descarga'), sortable: false }
      ]
      this.dRole = this.pLimitDate.roleUser
      if (this.dRole === 'CLIENTE') {
        this.dSelectClientIni = this.$store.getters.getAutenticacion.cliente
      }
      this.dDataClient = {
        'errorMessages': [],
        'label': 'clienteInicial',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('cliente'), align: 'left', value: 'codigo', column: 'cliente' },
          { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovClte',
        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'cliente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'request': this.dRequestClient,
        'default': this.dSelectClientIni,
        'disabled': false,
        'required': false,
        'orderByDefault': 'cliente',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': 'seleccionaUnCliente'
      }
      this.dDataSucursal = {
        'errorMessages': [],
        'label': this.$t('sucursal'),
        'rowsPerPage': 10,
        'headers': [
          { text: this.$t('sucursal'), align: 'left', value: 'codigo', column: 'sucursal' },
          { text: this.$t('nombreSucursal'), align: 'left', value: 'nombre', column: 'razonSocial' }
        ],
        'urlWS': 'lovDic',

        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'sucursal', 'nombre': 'razonSocial' },
        'resultName': 'dataRes',
        'request': null,
        'default': this.dSelectSucursal,
        'disabled': true,
        'required': true,
        'orderByDefault': 'sucursal',
        'orderDefault': 'sucursal',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': this.$t('seleccionaUnaSucursal'),
        'client': this.dSelectClientIni.codigo
      }

      if (this.pLimitDate.roleUser === 'CLIENTE' || this.pLimitDate.roleUser === 'MULTISUCURSAL') {
        this.dDataSucursal.disabled = false
        this.dDataSucursal.request = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          cliente: this.$store.getters.getAutenticacion.cliente
        }
      }
      this.dDatosFiltros = {
        'numAlbaran': '',
        'numDI': '',
        'estado': 'T',
        'fechaIni': null,
        'fechaIniString': '',
        'fechaIniMenu': null,
        'fechaMinIni': '',
        'fechaFin': null,
        'fechaFinString': '',
        'fechaFinMenu': null,
        'fechaMinFin': '',
        'idCliente': '',
        'idSucursal': '',
        'centroTrabajo': '',
        'codLER': ''
      }
      this.dDataProveedor = {
        'errorMessages': this.dErrorMsgProveedor,
        'label': 'proveedor',
        'rowsPerPage': this.dRowsPerPage,
        'headers': [
          { text: this.$t('proveedor'), align: 'left', value: 'codigo', column: 'codProveedor' },
          { text: this.$t('nombreProv'), align: 'left', value: 'nombre', column: 'nombreProveedor' }
        ],
        'urlWS': 'lovProv',

        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'codProveedor', 'nombre': 'nombreProveedor' },
        'resultName': 'dataRes',
        'request': this.dRequestProv,
        'default': this.dSelectProveedor,
        'disabled': false,
        'required': false,
        'orderByDefault': 'codProveedor',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': 'selectProveedor'
      }


      if (this.pLimitDate.roleUser === 'CLIENTE') {

        this.dDataSucursal.disabled = false
        this.dDataSucursal.request = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          cliente: this.$store.getters.getAutenticacion.cliente
        }
      }
    },
    fSelectClient(item) {
      if (item && item != null) {
        this.dSelectClientIni.codigo = item.codigo
        this.dSelectClientIni.nombre = item.nombre
        this.dDatosFiltros.idCliente = item.codigo
      }

      if (this.dRoleSelect === "SUCURSAL" && this.dSelectClientIni.codigo === undefined) {
        this.fCleanClient()
      }
      this.dDataSucursal.client = item.codigo
      this.dDataSucursal.request = {
        empresa: this.$store.getters.getAutenticacion.empresa,
        cliente: item.codigo
      }

      if (item.codigo !== '' && item.codigo !== undefined && this.$refs.TablaDeSucursal !== undefined) {

        this.$refs.TablaDeSucursal.fChangeDisabled(false)
      }
    },
    fCleanClient() {
      this.dSelectClientIni = {}
      if (this.$refs.TablaDeSucursal !== undefined) {

        this.$refs.TablaDeSucursal.fChangeDisabled(true)
        this.$refs.TablaDeSucursal.fClear()
      }
      if (this.$refs.TablaDeClient !== undefined) {
        this.$refs.TablaDeClient.fClean()
      }
      this.fClearSucursal()

    },
    fSelectSucursal(item) {
      this.dSelectSucursal.codigo = item.codigo
      this.dSelectSucursal.nombre = item.nombre
      this.dDatosFiltros.idSucursal = item.codigo
    },
    fClearSucursal() {
      this.dDataSucursal.disabled = true
      this.dSelectSucursal = {}
    },
    /**
     * valida el resto de reglas
     */
    fBuscarFacturas() {
      if (this.fValidateOtherRules()) {
        if (this.fCheckFiltrosPendientes()) {
          this.fLoadInvoices(this.dPagination.sortBy, this.dPagination.descending, this.page, this.dPagination.rowsPerPage, '', [])
        } else {
          this.dBuscarTxt = this.$t('buscar')
          this.$emit('alert', '<b>' + this.$t('avisoFactura') + '</b><br/>' + this.$t('filtersSuc'))
        }
      } else {
        this.dBuscarTxt = this.$t('buscar')
        this.$emit('alert', '<b>' + this.$t('reviseFiltrosBuscar') + '</b>')
      }
    },
    /**
     * valida el resto de reglas
     */
    fValidateOtherRules() {
      return this.dErrorMsgProveedor.length === 0
    },
    /**
     * comprueba si falta recibir información de algun filtro
     */
    fCheckFiltrosPendientes() {
      let finalvalue = false;
      if (this.dRole === 'CLIENTE') {
        this.dDatosFiltros.idCliente = this.$store.getters.getAutenticacion.cliente
        if (this.fNotEmpty(this.dSelectProveedor.codigo) || this.fNotEmpty(this.dSelectSucursal.sucursal) || this.fNotEmpty(this.dDatosFiltros.fechaIni) || this.fNotEmpty(this.dDatosFiltros.fechaFin)) {
          finalvalue = true
        }
      } else if (this.dRole === 'SUCURSAL') {
        this.dDatosFiltros.idCliente = this.$store.getters.getAutenticacion.cliente
        this.dSelectSucursal.sucursal = this.$store.getters.getAutenticacion.sucursal
        finalvalue = true
      } else {
        if (this.fNotEmpty(this.dSelectProveedor.codigo) || this.fNotEmpty(this.dDatosFiltros.idSucursal) || this.fNotEmpty(this.dDatosFiltros.fechaIni) || this.fNotEmpty(this.dDatosFiltros.fechaFin)) {
          finalvalue = true
        }
      }
      return finalvalue;
    },
    fCheckOnPremise() {
      return localStorage.getItem('isOnPremise') === 'yes'
    },
    /**
     * Metodo de limpieza de los filtros
     */
    fLimpiarFiltros() {
      // Limpia desplegables
      this.dErrorMsgProveedor = []
      if (this.dRole === 'ADMIN' || this.dRole === 'REPRESENTANTE') {
        this.dSelectProveedor = { codigo: '', nombre: '' }
        if (this.$refs.TablaDeProveedores) {
          this.$refs.TablaDeProveedores.fActualizarItem(this.dSelectProveedor)
        }
      }
      // Limpia fechas
      this.dDatosFechas.fechaIniMenu = false
      this.dDatosFechas.fechaIniDate = null
      this.dDatosFechas.fechaIniDateString = null
      this.dDatosFechas.fechaFinMenu = false
      this.dDatosFechas.fechaFinDate = null
      this.dDatosFechas.fechaFinDateString = null

      // Paginación
      this.dTotalItems = 0
      this.dPagination = { 'sortBy': 'fechaEntrada', 'descending': true, 'rowsPerPage': 5 }
    },
    /*
     * cambia el orden de an columna
     */
    fCambiaOrden(header) {
      if (header.sortable) {
        const column = header.value
        this.dPagination.page = 1
        this.dPagination.rowsPerPage = this.dRowsPerPage
        if (this.dPagination.sortBy === column) {
          this.dPagination.descending = !this.dPagination.descending
        } else {
          this.dPagination.sortBy = column
          this.dPagination.descending = false
        }
      }
    },
    /*
     * Metodo de carga de usuarios
     */

    fAddFilters(jsonEntrada) {
      // Parametros formulario

      // Proveedor
      if ((this.dSelectProveedor !== undefined) && (this.dSelectProveedor.codigo !== '') && (this.dSelectProveedor.codigo !== undefined)) {
        jsonEntrada.proveedor = this.dSelectProveedor.codigo
      }

      // Sucursal
      if ((this.dSelectSucursal !== null) && (this.dSelectSucursal !== '')) {
        jsonEntrada.sucursal = this.dSelectSucursal.codigo
      }
      if (this.dSelectClientIni !== null && this.dSelectClientIni !== '') {
        jsonEntrada.cliente = this.dSelectClientIni.codigo
      }

      if (this.dRole === 'CLIENTE') {
        jsonEntrada.cliente = this.$store.getters.getAutenticacion.cliente
      }

      if (this.dRole === 'SUCURSAL') {
        jsonEntrada.cliente = this.$store.getters.getAutenticacion.cliente
        jsonEntrada.sucursal = this.$store.getters.getAutenticacion.sucursal
      }

      if (jsonEntrada.cliente !== undefined && jsonEntrada.cliente !== null) {
        const payload = {
          tira: this.$store.getters.getAutenticacion.tira,
          usuario: this.$store.getters.getAutenticacion.usuario,
          empresa: jsonEntrada.empresa,
          cliente: jsonEntrada.cliente
        }
        SrvGeneral.lovClte(payload).then(respuesta => {
          if (respuesta.data.dataRes.length > 0) {
            jsonEntrada.proveedor = respuesta.data.dataRes[0].codigoAcreedor
          } else {
            this.$emit('alert', '<b>' + this.$t('notFoundDefault') + '</b><br>' + this.$t('notFoundDefaultDesc'))
          }
        }).catch(error => {
          this.fErrorComprobado(error.response)
        })
      }

      // rango fechas
      if ((this.dDatosFechas.fechaIniDateString !== null) && (this.dDatosFechas.fechaIniDateString !== '')) {
        jsonEntrada.fechaIni = this.dDatosFechas.fechaIniDateString
      } else if (this.dDatosFechas.fechaMinIni !== '' && this.dDatosFechas.fechaMinIni !== null && (this.dDatosFechas.fechaIniDateString === '' || this.dDatosFechas.fechaIniDateString == null)) {
        jsonEntrada.fechaIni = this.$moment(this.dDatosFechas.fechaMinIni, this.dDateFormats.years).format(this.dDateFormats.default)
      }

      if ((this.dDatosFechas.fechaFinDateString !== null) && (this.dDatosFechas.fechaFinDateString !== '')) {
        jsonEntrada.fechaFin = this.dDatosFechas.fechaFinDateString
      } else if (this.dDatosFechas.fechaMinFin !== '' && this.dDatosFechas.fechaMinFin !== null && (this.dDatosFechas.fechaFinDateString === '' || this.dDatosFechas.fechaFinDateString == null)) {
        jsonEntrada.fechaFin = this.$moment(this.dDatosFechas.fechaMinFin, this.dDateFormats.years).format(this.dDateFormats.default)
      }
    },
    fLoadInvoices(sortBy, descending, page, rowsPerPage, search, filters) {
      this.fEventLoading()
      this.dFilters = filters
      let offset = 1

      descending = (descending) ? 'DESC' : 'ASC'
      page = (page === undefined) ? 1 : page
      rowsPerPage = (rowsPerPage === undefined) ? this.dPagination.rowsPerPage : rowsPerPage
      filters = (filters === undefined) ? [] : filters

      if (sortBy === undefined) {
        sortBy = 'fechaEntrada'
        descending = 'DESC'
      }

      offset = this.dPagination.rowsPerPage * (page - 1) + 1

      // revisar la carga de datos y las columnas
      const jsonEntrada = {
        tira: this.$store.getters.getAutenticacion.tira,
        usuario: this.$store.getters.getAutenticacion.usuario,
        empresa: this.$store.getters.getAutenticacion.empresa,
        search: search,
        offset: offset,
        numRows: rowsPerPage,
        orderBy: sortBy,
        order: descending,
        filters: filters
      }

      // Función Add Filtros
      this.fAddFilters(jsonEntrada)
      if (jsonEntrada.fechaFin !== '' && jsonEntrada.fechaIni !== '') {
        SrvImpresion.getAlbaranProveedor(jsonEntrada).then(respuesta => {
          if (respuesta.data.dataRes.length > 0) {
            this.dAlbaranes = respuesta.data.dataRes
            this.dTotalItems = respuesta.data.numReg
          } else {
            this.$emit('alert', '<b>' + this.$t('notFoundDefault') + '</b><br>' + this.$t('notFoundDefaultDesc'))
          }
          this.fEventLoading()
        }).catch(error => {
          this.fEventLoading()
          this.fErrorComprobado(error.response)
        })
      } else {
        this.fEventLoading()
        this.$emit('alert', '<b>' + this.$t('notValidDate') + '</b><br>' + this.$t('notValidDateDesc'))
      }
    },
    fErrorComprobado(error) {
      if (error !== undefined) {
        if (error.data.statusText !== undefined) {
          this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br/>' + error.data.statusText + '  (' + error.data.statusCode + ' ) ')
        }
        if (error.data.exception !== undefined) {
          this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br/>' + error.data.exception)
        }
        if (error.data.errorMsg !== undefined) {
          this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br/>' + error.data.errorMsg)
        }
      }
    },
    /**
     * Busca el role del usuarios para ver que ha de mostrar
     */
    formatPrice(value) {
      const spanishFormatter = new Intl.NumberFormat('de-DE')
      return spanishFormatter.format(value)
    },
    fIniciarFechas() {
      const dateIni = new Date()
      dateIni.setDate(dateIni.getDate() - 7)

      let mes = this.fPadTo2Digits(dateIni.getMonth() + 1)
      let dia = this.fPadTo2Digits(dateIni.getDate())
      if (this.dDatosFechas.fechaMinIni !== '') {
        const dateIniFechaRol = new Date(this.dDatosFechas.fechaMinIni)
        dateIniFechaRol.setHours(0, 0, 0, 0)
        if (dateIniFechaRol <= dateIni) {
          this.dDatosFechas.fechaIniDateString = dia + '/' + mes + '/' + dateIni.getFullYear()
        } else {
          const dateNow = new Date()
          dateNow.setHours(0, 0, 0, 0)
          const dateInTime = dateNow.getTime() - dateIniFechaRol.getTime()
          this.dDiasAnteriores = dateInTime / (1000 * 3600 * 24)
          this.dDatosFechas.fechaIniDateString = this.$moment(this.dDatosFechas.fechaMinIni, this.dDateFormats.years).format(this.dDateFormats.default)
        }
      } else {
        this.dDatosFechas.fechaIniDateString = dia + '/' + mes + '/' + dateIni.getFullYear()
      }
      const dateFin = new Date()
      mes = this.fPadTo2Digits(dateFin.getMonth() + 1)
      dia = this.fPadTo2Digits(dateFin.getDate())
      if (this.dDatosFechas.fechaMinFin !== '') {
        const dateFinFechaRol = new Date(this.dDatosFechas.fechaMinFin)
        if (dateFinFechaRol <= dateFin) {
          this.dDatosFechas.fechaFinDateString = dia + '/' + mes + '/' + dateFin.getFullYear()
        } else {
          this.dDatosFechas.fechaFinDateString = this.$moment(this.dDatosFechas.fechaMinFin, this.dDateFormats.years).format(this.dDateFormats.default)
        }
      } else {
        this.dDatosFechas.fechaFinDateString = dia + '/' + mes + '/' + dateFin.getFullYear()
      }
    },
    fPadTo2Digits(num) {
      return num.toString().padStart(2, '0')
    },
    fFormatPedido(tipoPedido) {
      switch (tipoPedido) {
        case 'P':
          return 'Pedido'
        case 'A':
          return 'Abono'
        case 'C':
          return 'Cargo'
        default:
          return 'Otros'
      }
    },
    /**
     * Metodo de descarga del informes
     */
    fDownloadReport(albaran) {
      // prepara los parametros generales de busqueda
      this.fEventLoading()

      const jsonEntrada = {
        empresa: this.$store.getters.getAutenticacion.empresa,
        albaran: albaran.numAlbaran,
        ocCompra: albaran.ocCompra,
        proveedor: albaran.proveedor,
        fecha: this.formatDate(albaran.fechaEntrada)
      }

      SrvImpresion.getReportAlbaranProv(jsonEntrada).then(response => {
        if (response.status === 200) {
          if (response.data.dataRes.url && response.data.dataRes.url !== '') {
            window.open(response.data.dataRes.url)
            if (response.data.dataRes.urlProveedor) {
              window.open(response.data.dataRes.urlProveedor)
            }
          } else {
            this.$emit('alert', '<b>' + this.$t('notAlbaranFound') + '</b><br> ' + this.$t('notAlbaranFoundDesc'))
          }
        } else {
          this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
        this.fEventLoading()
      }).catch(error => {
        this.fErrorComprobado(error.response)
        this.fEventLoading()
      })
    },
    fOpenUrls(datos) {
      datos.forEach(item => {
        if (item.url && item.url !== '') {
          window.open(item.url, '_blank')
        }
      })
    },
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    fToggleAll() {
      if (this.dSelectedAll) {
        this.dSelected = []
        this.dSelectedAll = false
      } else {
        this.dSelected = this.dAlbaranes.slice()
        this.dSelectedAll = true
      }
    },
    fLimitFechas() {
      if (this.pLimitDate.fechaIniLimit !== '' && this.pLimitDate.fechaIniLimit !== null) {
        this.dFechaMinIni = this.$moment(this.pLimitDate.fechaIniLimit, this.dDateFormats.years).format(this.dDateFormats.years)
      }
      if (this.pLimitDate.fechaFinLimit !== '' && this.pLimitDate.fechaFinLimit !== null) {
        this.dFechaMinFin = this.$moment(this.pLimitDate.fechaFinLimit, this.dDateFormats.years).format(this.dDateFormats.years)
      }
    },
    fNotEmpty(value) {
      let finalvalue = false;
      if (value !== undefined && value !== null && value !== '') {
        finalvalue = true;
      }
      return finalvalue;
    },
    fRespuestaCorrecta(response) {
      let finalvalue = false;
      if (response.status === 200 && response.data.result !== 'ko' && (response || response.data !== undefined || response.data.dataRes.result !== undefined || response.data.dataRes.result !== null)) {
        finalvalue = true;
      } 
      return finalvalue;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.buttonBar .card__title {
  padding: 8px !important;
}

.buttonBarSearch .card__title {
  padding: 0px !important;
}

.buttonBarSearchTop .card__text {
  padding-top: 4px !important;
  padding-bottom: -10px !important;
}

.numberInputSpinnerInput .vnis__input {
  background: #ffffff !important;
  border: 0px !important;
  border-bottom: 1px solid #999999 !important;
}

.numberInputSpinnerButton .vnis__button {
  background: #ffffff !important;
  color: #000000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Informes/Albaranes/ShpAlbaranesProveedor.vue